import React from "react";
import "./Logout.scss";
//import { MotifProgressLoader } from "@ey-xd/motif-react";
import { MSAL_CONFIG } from "../../common/security/authConfig";
import EYP from '../../common/images/EYP.svg'

export const Logout = () => {
  //const [isLoading, setIsLoading] = React.useState(false);


  React.useEffect(() => {
    // Clear any cached flags or session storage related to authentication
    sessionStorage.clear();
    localStorage.clear();
  }, []);

  return (
    <div className="Logout">
      <div className="logout-header">
        <div className="logo">
          <img src={EYP} alt="logo" />
        </div>
      </div>
      <div className="logout-right">
        <div className="logout-right-wrapper">
          <div className="section_logout">
            <span>You have been logged out from the Application. </span>
            <span>Please <a href={MSAL_CONFIG.auth.redirectUri}>Click here</a> to login.</span>
          </div>
        </div>
      </div>
    </div>
  );
};
